import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  language: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  current_page: 1,
  per_page: PAGELENGTH,
  last_page: 1
}

export const languageSlice = createSlice({
  name: 'language',
  initialState: initialState,
  reducers: {
    setLanguage: (state, { payload }) => {
      state.language = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setLanguages: (state, { payload }) => {
      state.language = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setMoreLanguages: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    removeLanguage: (state, { payload }) => {
      state.error = payload
    },
    clearAllLanguage: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

// const reducer = (state = initialState, action) => {
//   switch (action.type) {
//     case types.INIT_APP:
//     case types.GO_TO_DETAILS:
//       return { ...state, ...action.payload }
//     default:
//       return state
//   }
// }

export const addLanguage = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.addLanguage(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setLanguage(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const updateLanguage = (data, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateLanguage(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setLanguage(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeLanguage = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeLanguage(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setLanguage(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const fetchLanguages = (page, params, disableLoader, Aync) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchLanguages(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setLanguages(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setLanguages(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }
  } catch (error) {
    console.log("error", error)
  }
}

export const fetchTiersLanguages = (page, params, disableLoader, Aync) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchTiersLanguages(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          return result?.data?.data;
        } else {
          // dispatch(setLanguages(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        } else {
          // dispatch(setLanguages(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }
  } catch (error) {
    console.log("error", error)
  }
}
export const changeStatus = (id, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.statusChange(id, data, 'language')
    if (json.status >= 200 && json.status < 300) {
      // console.log(json)
      // dispatch(setHospital(json.data))
      // callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      // callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeMultipleLanguages = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeMultipleLanguages(ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setHospital(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const { setLanguage, setLanguages, clearAllLanguage, setLoader, setError, setMoreLanguages } = languageSlice.actions


export default languageSlice.reducer
export const languageSelector = state => state.language


